import { render, staticRenderFns } from "./GoogleRedirectFrom.vue?vue&type=template&id=78537f9f&scoped=true"
import script from "./GoogleRedirectFrom.vue?vue&type=script&lang=js"
export * from "./GoogleRedirectFrom.vue?vue&type=script&lang=js"
import style0 from "./GoogleRedirectFrom.vue?vue&type=style&index=0&id=78537f9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78537f9f",
  null
  
)

export default component.exports